import { createLogger } from '@/logger';
import { createUser, createCredentials } from './cognito';

const log = createLogger('auth.login');

function errorToFriendlyMessage(err) {
  if (err.code === 'PasswordResetRequiredException') {
    log.information({ message: 'Password reset required for user.' });
    return 'A password reset is required before you can log in.';
  }

  if (err.code === 'UserNotFoundException') {
    log.debug({ message: 'Login attempt for unknown email.' });
    return 'No user with that email.';
  }

  if (err.code === 'NotAuthorizedException') {
    log.debug({ message: 'Login attempt with incorrect password.' });
    return 'Incorrect password.';
  }

  log.error({
    message: 'Encountered unmatched error during login.',
    exception: err,
  });

  return err.message;
}

export default function login({ username, password, success, error, forcepw }) {
  const user = createUser(username);

  user.authenticateUser(createCredentials(username, password), {
    onSuccess: (res) => {
      log.information({ message: 'User logged in.' });
      success(res.getIdToken().getJwtToken());
    },

    onFailure: err => error(errorToFriendlyMessage(err)),

    newPasswordRequired: () => {
      log.information({
        message: 'First login attempt for admin-created user. Extra information required.',
      });

      forcepw(({ newPassword, given_name, family_name }) => {
        const attrs = { given_name, family_name };

        log.information({
          message: 'Updating information for admin-created user.',
        });

        user.completeNewPasswordChallenge(newPassword, attrs, {
          onSuccess: res => success(res.getIdToken().getJwtToken()),
          onFailure: err => error(errorToFriendlyMessage(err)),
        });
      });
    },
  });
}



// WEBPACK FOOTER //
// ./src/auth/login.js